module.exports = __webpack_public_path__ + "img/777.a3809836.svg";